import {
  Children,
  type ElementType,
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react';

import { IntentProps } from '../../../../../core/slots/Intent/Intent.js';
import { isSlot } from '../../../../../core/utils/is-slot.js';
import type { MenuItemProps } from '../../../../../navigation/menu/Item.js';
import { ActionProps } from '../../overlay-tooltip/components/global-actions/Action.js';
import { OverlayTooltip } from '../../overlay-tooltip/OverlayTooltip.js';
import { ChartSeriesAction } from '../../series-action/ChartSeriesAction.js';

const renderActionItem = (
  item: ReactElement<PropsWithChildren<MenuItemProps<ElementType>>>,
) => {
  const itemProps: ActionProps = {
    disabled: item.props.disabled,
    onSelect: item.props.onSelect,
    label: '',
    icon: '',
  };

  Children.forEach(item.props.children, (itemPart) => {
    if (isSlot(itemPart, ChartSeriesAction.ItemIcon)) {
      itemProps.icon = itemPart.props.children;
    } else {
      itemProps.label = itemPart;
    }
  });

  return (
    <OverlayTooltip.Action
      label={itemProps.label}
      icon={itemProps.icon}
      onSelect={itemProps.onSelect}
      disabled={itemProps.disabled}
    />
  );
};

export const getCustomContextMenuItems = (customItem: ReactNode) => {
  let actions: ReactElement<PropsWithChildren<MenuItemProps<ElementType>>>[] =
    [];
  let intents: ReactElement<PropsWithChildren<IntentProps>>[] = [];

  Children.forEach(customItem, (action) => {
    if (isSlot(action, ChartSeriesAction)) {
      const { actions: recursiveActions, intents: recursiveIntents } =
        getCustomContextMenuItems(action.props.children);
      actions = [...actions, ...recursiveActions];
      intents = [...intents, ...recursiveIntents];
    } else if (isSlot(action, ChartSeriesAction.Item)) {
      actions = [...actions, renderActionItem(action)];
    } else if (isSlot(action, ChartSeriesAction.Intent)) {
      intents = [...intents, action];
    }
  });

  return { actions, intents };
};
